import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  FormBuilder,
  FormControl,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';

import { Store } from '@ngrx/store';

import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';

import {
  ActionState,
  AppInputDirective,
  AutofocusDirective,
  ButtonComponent,
  customEmailValidator,
  FormFieldComponent,
  FormFieldLabelComponent,
  getRequestPasswordResetActionState,
  Go,
  LogoComponent,
  MessageComponent,
  RequestPasswordReset
} from '@ui/legacy-lib';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-request-password-reset',
  templateUrl: './request-password-reset.component.html',
  styleUrls: ['./request-password-reset.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LogoComponent,
    TranslateModule,
    FormFieldLabelComponent,
    FormFieldComponent,
    AppInputDirective,
    AutofocusDirective,
    ReactiveFormsModule,
    AsyncPipe,
    MessageComponent,
    ButtonComponent
  ]
})
export class RequestPasswordResetComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private store = inject(Store);
  private formBuilder = inject(FormBuilder);

  public emailControl: FormControl;
  public errorMessage$: Observable<string>;
  public actionState$: Observable<ActionState>;

  ngOnInit() {
    const email = this.route.snapshot.queryParams.email || '';

    this.emailControl = this.formBuilder.control(email, [
      Validators.required,
      customEmailValidator
    ]);

    this.actionState$ = this.store
      .select(getRequestPasswordResetActionState)
      .pipe(share());
  }

  public submit() {
    if (this.emailControl.invalid) {
      return;
    }
    this.errorMessage$ = this.store
      .select(getRequestPasswordResetActionState)
      .pipe(
        map(actionState =>
          actionState.error ? actionState.error.message : null
        )
      );
    const email = this.emailControl.value;
    this.store.dispatch(new RequestPasswordReset(email));
  }

  public cancel() {
    this.store.dispatch(new Go({ path: ['/login'] }));
  }
}
